<template>
    <div class="t-not-find-event" :class="{_lk: isLk}">
        <div :class="{'t-lk-container': isLk, 't-container': !isLk}">
            <transition name="fadeRight">
                <div v-if="infoForm.success" class="t-not-find-event__container">
                    <success-cmp
                        :props="{
                            title: $root.staticText.modal.successTitleReg,
                            text: $root.staticText.modal.successText,
                            // btnEvent: $root.staticText.modal.successBtnEvent,
                            // btnCalendar: $root.staticText.modal.successBtnCalendar
                        }"
                    >
                    </success-cmp>
                </div>
            </transition>
            <transition name="fadeRight">
                <div v-if="infoForm.error" class="t-not-find-event__container">
                    <error-cmp
                        :props="{
                            title: $root.staticText.modal.errorTitleReg,
                            text: $root.staticText.modal.errorText
                        }"
                    >
                    </error-cmp>
                </div>
            </transition>
            <transition name="fadeRight">
                <div v-show="!infoForm.success && !infoForm.error" class="t-not-find-event__container">
                    <h2 class="t-not-find-event__title t-subtitle">{{ title }}</h2>
                    <div class="t-not-find-event__text">{{ text }}</div>
                    <form
                        class="t-not-find-event-form t-form"
                        @submit.stop.prevent="submitForm()"
                        :class="{_disabled: infoForm.disabledForm}"
                    >
                        <div class="t-not-find-event-form__content">
                            <div class="t-not-find-event-form__item" v-for="(item, index) in form">
                                <div class="t-form__label">
                                    {{ item.label }}
                                    <span v-if="item.required">*</span>
                                </div>
                                <div class="t-not-find-event-form__input">
                                    <select-custom-cmp
                                        v-if="item.type === 'select'"
                                        :data="item"
                                    >
                                    </select-custom-cmp>

                                    <input
                                        v-if="item.type === 'text'"
                                        class="t-input"
                                        :class="{'_error': item.error, '_valid': item.valid}"
                                        :type="item.type"
                                        :placeholder="item.hintField"
                                        :id="'not-find-event-' + item.name"
                                        v-model="item.value"
                                        @focus="focusForm(index)"
                                    />
                                    <textarea
                                        v-if="item.type === 'textarea'"
                                        class="t-textarea"
                                        :placeholder="item.hintField"
                                        :id="item.name"
                                        v-model="item.value"
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="!$route.fullPath.includes('/lk')"
                            class="t-personal-data"
                            :class="{_error: infoForm.errorPersonalData}"
                        >
                            <input
                                @change="changePersonalDataFrom()"
                                type="checkbox"
                                id="personal-data"
                                class="t-personal-data__input"
                            />
                            <label for="personal-data">
                                <svg width="16" height="12" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z" fill="white"/>
                                </svg>
                                {{$root.staticText.forms.agree}}
                                <a href="/user-agreement" target="_blank" class="t-personal-data__link">
                                    {{$root.staticText.forms.personalData}}
                                </a>
                            </label>
                        </div>

                        <vue-recaptcha
                            ref="recaptcha"
                            size="invisible"
                            :sitekey="$root.sitekeyRecaptcha"
                            :load-recaptcha-script="true"
                            @verify="onCapchaRegister"
                            @expired="onCaptchaExpired"
                            @error="errorCaptcha"
                        />
                        <button class="t-btn _green t-not-find-event-form__btn">
                            {{ $root.staticText.forms.btn }}
                        </button>
                    </form>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import selectCustom from '@components/ui-components/select-custom/select-custom-dynamic.vue';
    import success from '@components/base/modals/success';
    import error from '@components/base/modals/error';
    import { validate, sendForm, changePersonalDataFrom, focusForm } from '@assets/js/formObjects.js';
    import VueRecaptcha from "vue-recaptcha";
import { watch } from 'vue';

    export default {
        name: "not-find-event",
        props: {
            title: String,
            text: String,
            list: {
                type: Array,
                default: () => []
            },
            isLk: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                recaptchaToken: null,
                isValid: false,
                infoForm: {
                    action: 'notFindEvent',
                    disabledForm: false,
                    isPersonalData: false,
                    errorPersonalData: false,
                    success: false,
                    error: false,
                },
                form: [
                    {
                        label: this.$root.staticText.forms.decision,
                        name: 'decision',
                        type: 'select',
                        value: [],
                        hintField: this.$root.staticText.forms.placeholderDecision,
                        error: false,
                        valid: false,
                        required: true,
                        pattern: '',
                        list: []
                    },
                    {
                        label: this.$root.staticText.forms.company,
                        name: 'company',
                        type: 'text',
                        value: '',
                        hintField: this.$root.staticText.forms.placeholderCompany,
                        error: false,
                        valid: false,
                        required: true,
                        pattern: /[a-zа-яё]{2,}/
                    },
                    {
                        label: this.$root.staticText.forms.name,
                        name: 'name',
                        type: 'text',
                        value: '',
                        hintField: this.$root.staticText.forms.placeholderName,
                        error: false,
                        valid: false,
                        required: true,
                        pattern: /[a-zа-яё]{2,}/
                    },
                    {
                        label: this.$root.staticText.forms.email,
                        name: 'email',
                        type: 'text',
                        value: '',
                        hintField: this.$root.staticText.forms.placeholderEmail,
                        error: false,
                        valid: false,
                        required: true,
                        pattern: /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/i
                    },
                    {
                        label: this.$root.staticText.forms.comment,
                        name: 'comment',
                        type: 'textarea',
                        value: '',
                        hintField: this.$root.staticText.forms.placeholderComment,
                        error: false,
                        valid: false,
                        required: false,
                        pattern: ''
                    }
                ]
            }
        },
        components: {
            'select-custom-cmp': selectCustom,
            'success-cmp': success,
            'error-cmp': error,
            VueRecaptcha,
        },
        methods: {
            onCapchaRegister(recaptchaToken) {
                this.recaptchaToken = recaptchaToken;
                if (this.isValid) {
                    this.send();
                }
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset();
            },
            errorCaptcha() {
                console.log('errorCaptcha');
            },

            submitForm() {
                this.validate();

                if (this.isValid) {
                    this.$refs.recaptcha.execute();
                }
            },
            validate() {
                this.isValid = validate(this.form, this.infoForm, this.$route);
            },
            send() {
                return {...sendForm(this.form, this.infoForm, this.recaptchaToken)};
            },
            changePersonalDataFrom() {
                return {...changePersonalDataFrom(this.infoForm)};
            },
            focusForm(i) {
                return {...focusForm(this.form, i)};
            },
        },
        mounted () {
            this.form[0].list = Array.isArray(this.list) ? [ ...this.list ] : [];
        }
    }
</script>

<style lang="sass">
    @import "../../../../sass/params"

    .t-not-find-event
        padding: 64px 0
        background-color: #fff
        overflow: hidden
        &._lk
            .t-not-find-event__title
                font-size: 32px
                color: $dark-shades-black
            .t-not-find-event__text
                margin-top: 16px
                color: $gray-secondary
                line-height: 140%
            .t-not-find-event-form__item
                .t-textarea
                    height: 136px
        &__title
            color: #000
        &__text
            margin-top: 12px
            color: $gray-footer
        &-form
            margin-top: 32px
            &__content
                display: flex
                flex-direction: column
                flex-wrap: wrap
                max-height: 204px
                margin-bottom: 4px
            &__item
                margin-bottom: 28px
                &:not(:last-child)
                    margin-right: 32px
                .t-textarea
                    height: 144px
            &__btn.t-btn
                margin-top: 32px
                min-width: 180px
                line-height: 140%
                font-size: 16px

        @media screen and (min-width: $desktop-medium)
            &._lk
                padding: 88px 0
                .t-not-find-event__title
                    font-size: 40px
                .t-not-find-event-form__item
                    .t-textarea
                        height: 158px
            &-form
                margin-top: 40px
                &__content
                    max-height: 258px
                &__item
                    margin-bottom: 40px
                    &:not(:last-child)
                        margin-right: 48px
                    .t-textarea
                        height: 182px
                &__btn.t-btn
                    margin-top: 48px

        @media screen and (min-width: $desktop-big)
            padding: 136px 0
            &._lk
                .t-not-find-event-form__item
                    .t-textarea
                        height: 182px
            &__text
                margin-top: 24px
                font-size: 24px
            &-form
                margin-top: 56px
                &__content
                    max-height: 280px
                &__btn.t-btn
                    margin-top: 56px
                    font-size: 18px
                &__item
                    .t-textarea
                        height: 196px

        @media screen and (max-width: $tablet-size)
            padding: 48px 0
            &._lk
                .t-not-find-event__title
                    font-size: 24px

        @media screen and (max-width: $mobile-size)
            padding: 32px 16px
            &._lk
                .t-not-find-event__text
                    font-size: 14px
            &__title
                font-size: 24px !important
            &__text
                font-size: 16px
                margin-top: 16px
                line-height: 140%
            &-form
                margin-top: 24px
                &__content
                    max-height: 100%
                    margin-bottom: 8px
                &__item
                    margin-bottom: 16px
                    &:not(:last-child)
                        margin-right: 0
                &__btn.t-btn
                    min-width: 100%

</style>


// WEBPACK FOOTER //
// src/templates/components/ui-components/not-find-event/not-find-event.vue